/* eslint-disable jsx-a11y/anchor-is-valid */
import { useRef } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CHPlayIcon from 'assets/icons/chPlay.png';
import TPestLogo from 'assets/icons/T-PestLogo.png';
import AppleStoreIcon from 'assets/icons/appStore.png';
import useStyles from './style';

function WelcomeApp() {
  const classes = useStyles();
  const googleRef = useRef(null);
  const appleRef = useRef(null);
  const { t } = useTranslation();
  return (
    <div className={classes.welcome}>
      <div className={classes.background}>
        <div>
          <div className={classes.title}>{t('welcomeTo')}</div>
          <div className={classes.title}>{t('toTPest')}</div>
          <img src={TPestLogo} alt="" />
        </div>
      </div>
      <div className={classes.action}>
        <div className={classes.actionContainer}>
          <div className={classes.actionTitle}>
            {t('dowwnloadTPEstSlogan')}
          </div>
          <div className={classes.btnContainer}>
            <Button
              sx={{
                padding: '5px 5px',
                borderRadius: '8px',
                '& .MuiButton-startIcon': {
                  marginLeft: '5px',
                  marginRight: '5px',
                },
                backgroundColor: '#FFFFFF',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 1)',
                },
              }}
              variant="outlined"
              color="primary"
              startIcon={<img src={CHPlayIcon} alt="" />}
              onClick={() => googleRef.current.click()}
            >
              <div>
                <div className={classes.textGoogle}>{t('downloadApplicationOn')}</div>
                <div className={classes.iconGoogle}>{t('googlePlay')}</div>
              </div>
            </Button>
            <Button
              sx={{
                padding: '5px 5px',
                borderRadius: '8px',
                '& .MuiButton-startIcon': {
                  marginLeft: '5px',
                  marginRight: '5px',
                },
                backgroundColor: '#FFFFFF',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 1)',
                },
              }}
              variant="outlined"
              color="primary"
              startIcon={<img src={AppleStoreIcon} alt="" />}
              onClick={() => appleRef.current.click()}
            >
              <div>
                <div className={classes.textApple}>{t('downloadApplicationOn')}</div>
                <div className={classes.iconApple}>{t('appleStore')}</div>
              </div>
            </Button>
            <a className={classes.disable} href="https://play.google.com/store/apps/details?id=com.tma.tpest.development" ref={googleRef}>Google Play</a>
            <a className={classes.disable} href="https://apps.apple.com/us/app/t-pest/id6463198299" ref={appleRef}>Apple Store</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomeApp;
